var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_182_3361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 13.3334V16.6667C16.6665 17.1087 16.4909 17.5327 16.1783 17.8452C15.8658 18.1578 15.4419 18.3334 14.9998 18.3334H3.33317C2.89114 18.3334 2.46722 18.1578 2.15466 17.8452C1.8421 17.5327 1.6665 17.1087 1.6665 16.6667V5.00004C1.6665 4.55801 1.8421 4.13409 2.15466 3.82153C2.46722 3.50897 2.89114 3.33337 3.33317 3.33337H6.6665",
    stroke: "#0054A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 13.1667L18.3332 5.16669L14.8332 1.66669L6.9165 9.58335L6.6665 13.3334L10.4165 13.1667Z",
    stroke: "#0054A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_182_3361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.d8198d3f9622ef587b5f214a5751d344.svg";
export { ForwardRef as ReactComponent };